export default [
  {
    path: '/partners-spends-logs',
    name: 'PagePartnersSpendsLogs',
    meta: { title: 'partnerSpendLog.listTitle', roles: ['ADMIN'], permissions: ['partner_spend_log_view'] },
    component: () => import('@/pages/partners-spends-logs'),
  },
]
